module.exports = __webpack_public_path__ + "img/cases-brand-12-cover.7da572cb.png";